/**
 * Check if the Clipboard API is supported in the current browser
 * @returns {boolean} true if clipboard is supported, false otherwise
 */
export default function isClipboardSupported(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    typeof navigator.clipboard !== 'undefined' &&
    typeof document !== 'undefined' &&
    document.queryCommandSupported?.('copy') !== false
  );
}
